import {
  Component,
  Output,
  EventEmitter,
  Input,
  OnInit,
  ViewChild,
  ElementRef
} from '@angular/core';
import { TokenService } from '../../../token.service';
import {
  FileDetailsDTO,
  Link,
  DocumentClassDTO,
  I18nData,
  DocumentClassConfigurationDTO
} from '../../../api/plyca-dtos';
import { ServiceLocator } from '../../../ServiceLocator';
import { PlycaDataService } from '../../../../services/plyca.service';
import { Configuration } from '../../../conf/app.constants';
import { SignatureService } from '../../../../services/signature.service';
import { UIService } from '../../../ui.service';
import { WaitLoadingService } from '../waitLoading/wait-loading.service';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../../auth.service';
import { FileUploader, FileUploaderOptions, FileItem, ParsedResponseHeaders } from 'ng2-file-upload';
import { isArray } from 'lodash';
import { BaseComponent } from '../baseComponent/base.component';
import { SignatureResponse } from '../../../../services/signature/signature.objects';
import { SignatureUtils } from '../../../../services/signature.utils';

@Component({
  selector: 'upload-files',
  templateUrl: 'upload.template.html',
  providers: [UIService]
})
export class UploadFilesComponent extends BaseComponent implements OnInit {
  private plycaService: PlycaDataService;
  public uploader: FileUploader = new FileUploader({});
  public hasBaseDropZoneOver = false;
  public hasAnotherDropZoneOver = false;
  private config: Configuration;
  private defaultFileUploaderOptions: FileUploaderOptions;
  private uiService: UIService;
  maximumFileSize: number;
  @Input() allowMultipleFiles: boolean;
  allowedFileExtensions: string[];
  itemToDeleteOnModify: FileDetailsDTO;

  @Output() addItem = new EventEmitter();
  @Output() deleteItem = new EventEmitter();
  @Output() modifyItem = new EventEmitter();
  @Input() files: any;
  @Input() documentClass: DocumentClassDTO;
  @Input() cancelWaitWhenFinished = true;
  @Input() readonly = false;

  @ViewChild('uploadInput') public fileUpload: ElementRef;

  public fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  public fileOverAnother(e: any): void {
    this.hasAnotherDropZoneOver = e;
  }

  constructor(
    private tokenService: TokenService,
    private waitService: WaitLoadingService,
    private signatureService: SignatureService,
    private configuration: Configuration,
    private authService: AuthService,
    private signatureUtils: SignatureUtils
  ) {
    super();
    this.plycaService = ServiceLocator.injector.get(PlycaDataService);
    this.config = ServiceLocator.injector.get(Configuration);
    this.uiService = ServiceLocator.injector.get(UIService);
  }



  ngOnInit() {
    if (!this.files) {
      this.files = [];
    } else if (!isArray(this.files)) {
      this.files = [this.files];
    }


    let serviceUrl: string = this.config.ServerWithUserApiUrl + 'tmpfiles';
    this.defaultFileUploaderOptions = {
      url: serviceUrl,
      autoUpload: false,
      isHTML5: true,
      filters: [],
      removeAfterUpload: false,
      disableMultipart: false
    };

    if (this.documentClass && this.documentClass.identifier) {
      console.log(
        'Cargando configuración del upload del tipo de documento',
        this.documentClass
      );
      if (this.documentClass.configuration) {
        this.setDocumentClassConfig(this.documentClass.configuration);
      } else {
        this.subscribe(this.plycaService.get<DocumentClassDTO>(this.configuration.DOCUMENTCLASS_SERVICE_URL, this.documentClass.identifier,
          {
            'expand': 'configuration'
          }),
          (documentClass: DocumentClassDTO) => this.setDocumentClassConfig(documentClass.configuration));
      }


      this.defaultFileUploaderOptions.additionalParameter = {
        documentClassId: this.documentClass.identifier
      };
    } else {
      console.log(
        'Utilizando configuración por defecto en el componente de upload'
      );
      this.maximumFileSize = 5 * 1024;
      // se configura con el parámetro de entrada
      // this.allowMultipleFiles = false;
      this.allowedFileExtensions = ['*'];
    }



    this.uploader.setOptions(this.defaultFileUploaderOptions);
    this.uploader.onErrorItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      this.waitService.cancelWaiting();
      item.remove();
      this.uploader.clearQueue();
      this.uploader.isUploading = false;
      let responseObject = JSON.parse(response);
      let msg = 'Upload.error.file';
      if (responseObject && responseObject.errors && responseObject.errors && responseObject.errors.length
        && responseObject.errors.length > 0) {
        if (responseObject.errors[0].message) {
          msg = responseObject.errors[0].message;
        }
      }
      this.uiService.showMessage(new I18nData(msg));
    };
    this.uploader.onCompleteItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (status != 200)
        return;
      let responseObject = JSON.parse(response);
      let links: Link[];
      links = responseObject.fileDetails.links;
      this.subscribe(this.plycaService.fileDetailsDocumentWithSignatures(links[0].href).pipe(finalize(() => {
        if (this.cancelWaitWhenFinished) {
          this.waitService.cancelWaiting();
        }
      })),
        (fileDetails: FileDetailsDTO) => {
          let lastSignature = this.signatureUtils.getFirstSignatureWithVerificationEror(
            fileDetails.signatures
          );
          let validSignature = true;
          if (lastSignature !== null) {
            let signatureCode = this.signatureUtils.getValidOrEmptySignatureCode(
              lastSignature
            );
            validSignature = this.signatureService.isValidSignatureCode(signatureCode);
            if (!validSignature)
              console.log('Se ha detectado una firma no valida');
          }

          let validateSignature = !this.documentClass || !this.documentClass.configuration || !this.documentClass.configuration.allowInvalidSignatures;
          if (!validateSignature)
            console.log('El tipo de documento permite firmas invalidas');

          if (validateSignature && !validSignature) {
            this.waitService.cancelWaiting();
            if (this.documentClass.configuration && (this.documentClass.configuration.invalidSignaturesPolicy === 'RECOMMENDATION')) {
              this.signatureService.showSignatureValidationDetails(
                lastSignature,
                fileDetails,
                this.onAcceptSignature.bind(this),
                this.onRejectSignature.bind(this)
              );
            } else {
              this.signatureService.showSignatureValidationDetails(lastSignature, fileDetails);
            }

          } else {
            this.onAcceptSignature(fileDetails);
          }
        },
        err => {
          this.waitService.cancelWaiting();
          console.error(err);
          this.uiService.showMessage(new I18nData('Upload.details.error'));
        }
      );
    };
    this.uploader.onAfterAddingFile = (item: FileItem) => {
      let canAddFile =
        this.canAdd();
      if (this.itemToDeleteOnModify === undefined && !canAddFile) {
        this.uiService.showMessage(new I18nData('Upload.noMoreFiles.error'));
      } else if (this.isInvalidSize(item)) {
        this.uiService.showMessage(new I18nData('Upload.maxSize', { max: this.maximumFileSize }));
      } else if (this.isEmptySize(item)) {
        this.uiService.showMessage(new I18nData('Upload.minSize'));
      } else if (this.isValidExtension(item)) {
        console.log('Añadido a la cola');
        this.upload(item);
      } else {
        this.uiService.showMessage(new I18nData('Upload.extension.error'));
      }
    };

    this.uploader.onBuildItemForm = (fileItem: FileItem, form: FormData): any => {
      if (fileItem['_b64sha1']) {
        form.append('base64HashSHA1', fileItem['_b64sha1']);
      }
    };
  }

  onAcceptSignature(fileDetails: FileDetailsDTO) {
    if (this.itemToDeleteOnModify != undefined) {
      let list = [];
      list['delete'] = this.itemToDeleteOnModify;
      list['add'] = fileDetails;
      this.modifyItem.emit(list);
      this.itemToDeleteOnModify = undefined;
    } else {
      // anyadir resultado de la firma
      this.addItem.emit(fileDetails);
    }
  }

  onRejectSignature(fileDetails: FileDetailsDTO) {

  }


  isInvalidSize(item: FileItem): boolean {
    return item.file && item.file.size && (item.file.size / 1024) > this.maximumFileSize;
  }
  isEmptySize(item: FileItem): boolean {
    return !item.file || item.file.size == 0;
  }


  public setDocumentClassConfig(configuration: DocumentClassConfigurationDTO): void {
    this.maximumFileSize = configuration.maximumFileSize;
    this.allowMultipleFiles = configuration.allowMultipleFiles;
    this.allowedFileExtensions = configuration.allowedFileExtensions;
  }

  public canAdd(): boolean {
    // si es editable y además:
    // o es el primer archivo que se adjunta
    // o permite más de uno
    return !this.readonly &&
      (this.allowMultipleFiles
        || (this.files != undefined && this.files.length == 0));
  }

  public canModify(): boolean {
    // si es editable y además:
    // o es el primer archivo que se adjunta
    // o permite más de uno
    return !this.readonly;
  }
  public canEdit(): boolean {
    // si es editable y si hay adjuntos que editar
    return !this.readonly && (this.files != undefined && this.files.length >= 1);
  }


  private isValidExtension(item: FileItem): boolean {
    let validExtension = false;
    let allowedFileExtensions: string[] = this.allowedFileExtensions;
    if (item._file) {
      let fileName: string = item._file.name;
      for (
        let i = 0;
        i < allowedFileExtensions.length && !validExtension;
        i++
      ) {
        validExtension =
          allowedFileExtensions[i] === '*' ||
          fileName.toLowerCase().endsWith(allowedFileExtensions[i]);
      }
    }
    return validExtension;
  }

  public upload(item: FileItem) {
    this.waitService.startWaiting();
    if (!this.authService.isTokenValid()) {
      this.subscribe(this.plycaService.ping(), () => this.uploadInternal(item));
    } else {
      this.uploadInternal(item);
    }
  }

  public uploadInternal(item: FileItem) {
    let authHeaderName = this.tokenService.getAuthHaderName();
    this.uploader.authTokenHeader = authHeaderName;
    this.uploader.authToken = 'Bearer ' + this.tokenService.getAccessToken();

    /* NO FUNCIONA EN IE11

    // Leemos el archivo y calculamos su hash
    var reader = new FileReader();
    var auxiliar = this;

    var hashdata = CryptoES.algo.SHA1.create();
    var file = item._file;
    var reader = new FileReader();
    var size = file.size;
    var chunk_size = Math.pow(2, 22);
    var chunks = [];

    var offset = 0;
    var bytes = 0;
    reader.onloadend = (e) => {
      if (reader.readyState == FileReader.DONE) {

        hashdata.update(auxiliar.arrayBufferToWordArray(reader.result));

        let chunk: any = reader.result;
        bytes += chunk.length;
        chunks.push(chunk);
        if ((offset < size)) {
          offset += chunk_size;
          var blob = file.slice(offset, offset + chunk_size);
          reader.readAsArrayBuffer(blob);
        } else {
          var hash = hashdata.finalize();
          const b64sha1 = CryptoES.enc.Base64.stringify(hash);

          item['_b64sha1'] = b64sha1;
          // Ahora que conocemos la hash ya podemos subir el fichero (el parametro _b64sha1 se utilizara al construir el form en el metodo onBuildItemForm)
          item.upload();

        };
      }
    };
    var blob = file.slice(offset, offset + chunk_size);
    reader.readAsArrayBuffer(blob);
    */
    item.upload();

  }

  /*
    arrayBufferToWordArray(fileResult) {
      var i8a = new Uint8Array(fileResult);
      return CryptoES.lib.WordArray.create(i8a, i8a.length);
    }
  */


  deleteFileItem(fileItem: FileDetailsDTO) {
    this.deleteItem.emit(fileItem);
  }

  private deleteFileItemById(identifier: string) {
    let fileItem: FileDetailsDTO;
    if (this.files) {
      for (let i = 0; i < this.files.length && !fileItem; i++) {
        if (identifier === this.files[i].identifier) {
          fileItem = this.files[i];
        }
      }
    }
    if (fileItem) {
      this.deleteFileItem(fileItem);
    }
  }

  public addSignature(updatedFileItem: SignatureResponse) {
    // si se trata de una firma, que tiene referencia a fichero firmado, eliminar el original firmado
    let target = updatedFileItem.request.file.identifier;
    if (target) {
      this.deleteFileItemById(target);
    }
    // añadir resultado de la firma
    this.addItem.emit(updatedFileItem.file);
  }

  public modifyFileItem(modifiedFileItem: FileDetailsDTO) {
    this.itemToDeleteOnModify = modifiedFileItem;

    if (this.canModify) {
      this.fileUpload.nativeElement.click();
      // this.modifyItem.emit(modifiedFileItem); , pasa al método onComplete
      // hay que esperar que se haya incluído el nuevo correcamte y sin cancelar
    }



  }

  public getAllowExtensions() {
    if (this.documentClass && this.documentClass.identifier
      && this.documentClass.configuration && this.documentClass.configuration.allowedFileExtensions) {
      return '.' + this.documentClass.configuration.allowedFileExtensions.join(',.');
    }
  }

}
